import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {ErrorSummaries} from 'views/AppLocals/factory/createEditableForm'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {createControlledFormField} from '../../factory/createFormField'
import Pure from "../../../../components/Pure";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {BooleanPicker} from "../../Exam/ExamContext";


export const formSchema = {
    active: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1'],
        children: [

            {
                name: 'active',
                label: 'active',
                component: createControlledFormField({
                    Component: BooleanPicker,
                }),
            },
        ],
    },
    variant_codes: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'Mã SKU',
                name: 'variant_code',
                component: createControlledFormField({
                    placeholder: 'Mã SKU',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Barcode / Link Kho',
                name: 'barcode',
                component: createControlledFormField({
                    placeholder: 'Barcode / Link Kho',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Ref ID',
                name: 'ref_id',
                component: createControlledFormField({
                    placeholder: 'Ref ID',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
    rate_qtty: {
        inline: true,
        className: 'grid grid-cols-1 lg:grid-cols-4 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'Giá niêm yết',
                name: 'compare_price',
                component: createControlledFormField({
                    placeholder: 'Giá niêm yết',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Giá bán lẻ',
                name: 'price',
                component: createControlledFormField({
                    placeholder: 'Giá bán lẻ',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Cân nặng (g)',
                name: 'weight',
                component: createControlledFormField({
                    placeholder: 'Cân nặng (g)',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Tồn ban đầu',
                name: 'quantity',
                component: createControlledFormField({
                    placeholder: 'Tồn ban đầu',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Đang phong tỏa',
                name: 'blocked_quantity',
                component: createControlledFormField({
                    placeholder: 'Tồn ban đầu',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Đã bán',
                name: 'sold_quantity',
                component: createControlledFormField({
                    placeholder: 'Tồn ban đầu',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },

    attribute_1: {
        inline: true,
        className: 'grid grid-cols-1 lg:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'code',
                name: 'attribute1_code',
                component: createControlledFormField({
                    placeholder: 'attribute1 code',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'name',
                name: 'attribute1_name',
                component: createControlledFormField({
                    placeholder: 'attribute1 name',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'value',
                name: 'attribute1_value',
                component: createControlledFormField({
                    placeholder: 'attribute1 value',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },

    attribute_2: {
        inline: true,
        className: 'grid grid-cols-1 lg:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'code',
                name: 'attribute2_code',
                component: createControlledFormField({
                    placeholder: 'attribute1 code',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'name',
                name: 'attribute2_name',
                component: createControlledFormField({
                    placeholder: 'attribute1 name',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'value',
                name: 'attribute2_value',
                component: createControlledFormField({
                    placeholder: 'attribute1 value',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
}

export const ProductVariantFormCreate = ({
                                             onCancel = NullAsDefault,
                                             onSubmit = NullAsDefault,
                                         }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}

        const {variant_code} = values ?? {}

        if (!variant_code) {
            errors.variant_code = t('required field')
        }

        return errors
    }

    const initialValues = useMemo(() => {
        return {
            active: 1,
            variant_code: undefined,
        }
    }, [])

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {
                    resetKey,
                    owner_id,
                    owner_type,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <ActionModalWrapper
                    action={
                        <FormActionGroups
                            submitProps={{
                                label: 'create',
                            }}
                        />
                    }>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.active,
                                    formSchema.variant_codes,
                                ]}
                            />
                        </Pure>

                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.rate_qtty,
                                ]}
                            />
                        </Pure>

                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.attribute_1,
                                    formSchema.attribute_2,
                                ]}
                            />
                        </Pure>

                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const ProductVariantFormEdit = ({
                                           onCancel = NullAsDefault,
                                           onSubmit = NullAsDefault,
                                           initialValues = {},
                                       }) => {
    const t = useTranslate()

    const _initialValues = useMemo(() => {
        const {
            ...rest
        } = initialValues ?? {}

        return {
            ...rest,
        }
    }, [initialValues])

    const validate = (values) => {
        let errors = {}
        const {variant_code} = values ?? {}
        if (!variant_code) {
            errors.variant_code = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    resetKey,
                    status_options,
                    ...rest
                } = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <ErrorSummaries/>
                <ActionModalWrapper
                    action={
                        <FormActionGroups
                            submitProps={{
                                label: 'save',
                            }}
                        />
                    }>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.active,
                                    formSchema.variant_codes,
                                ]}
                            />
                        </Pure>

                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.rate_qtty,
                                ]}
                            />
                        </Pure>

                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.attribute_1,
                                    formSchema.attribute_2,
                                ]}
                            />
                        </Pure>

                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}
